import { DomainForMigrationResponseDto } from '@lucidlink/dto/web-service-api';
import { arrayParserFromDto } from '#fetcher/parse-utils';
import { createDomainCryptoDto } from '#sdk/workspace-client/domain-manager/prepare-domain-crypto';
// eslint-disable-next-line @typescript-eslint/naming-convention -- We want the naming to reflect the migration number
export class Migration_3_EnsureDomainKeysForVerifiedDomains {
    adminCrypto;
    workspaceFetcher;
    constructor(adminCrypto, workspaceFetcher) {
        this.adminCrypto = adminCrypto;
        this.workspaceFetcher = workspaceFetcher;
    }
    async shouldExecute() {
        const adminMember = await this.adminCrypto.adminMember.get();
        return (adminMember.workspaceConfig?.m003_legacyDomainsKeysMigrated !== true);
    }
    async execute() {
        const legacyVerifiedDomains = await this.workspaceFetcher.get(['crypto-migration', 'legacy-verified-domains'], {
            parser: arrayParserFromDto(DomainForMigrationResponseDto),
        });
        const ssoCrypto = await this.adminCrypto.getSsoCrypto();
        const ssoSecretKey = await ssoCrypto.verifyAndGetSsoSecretKey();
        const adminKeys = await this.adminCrypto.verifyAndGetAdminKeys();
        const domainKeysUpdate = await prepareDomainKeysForMigration(legacyVerifiedDomains, ssoSecretKey, adminKeys);
        await this.workspaceFetcher.patch(['crypto-migration', 'legacy-verified-domains'], { body: domainKeysUpdate });
    }
}
const prepareDomainKeysForMigration = async (domains, ssoSecretKey, adminKeys) => {
    return Promise.all(domains.map((domain) => prepareDomainKeyForMigration(domain, ssoSecretKey, adminKeys)));
};
const prepareDomainKeyForMigration = async (domain, ssoSecretKey, adminKeys) => {
    const domainCrypto = await createDomainCryptoDto({
        adminKeys,
        ssoSecretKey,
        // As we are doing migration we are going to reuse the sso key as domain key
        domainCryptoKey: ssoSecretKey,
    });
    return {
        id: domain.id,
        ...domainCrypto,
    };
};
